import {
    Stack,
    TableRow,
    TableCell,
    Typography,
    IconButton,
    ButtonGroup,
    Menu,
    Divider,
    MenuItem,
} from '@mui/material';
import { FormatNumber, glb_sv } from 'src/utils';
import Label from 'src/components/label/Label';
import Iconify from 'src/components/iconify/Iconify';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import ToolTipCustomTakeDevice from '../list-take-device/modal/ToolTipCustomTakeDevice';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useRef } from 'react';
const ItemListBorrowDevice = ({
    item,
    STATUS_COLOR,
    return_name_status,
    valueSearch,
    dataRef,
    setVisibleRequestFixDevice,
    setVisibleConfirmFixDevice,
    index,
    openButton,
    setOpenChangeRequestDevice,
    setOpenTakeDevice,
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const user = glb_sv.userInfo;
    const isAdmin = user?.group_user === '1' || user?.group_user === '2';
    const [openEdit, setOpenEdit] = useState(false);
    const anchorTabEdit = useRef(null);
    return (
        <TableRow hover key={index} tabIndex={-1} role="checkbox">
            <TableCell padding="checkbox"></TableCell>
            <TableCell
                align="left"
                style={{ minWidth: '250px' }}
                onClick={(e) => {
                    if (['cdr', 'rde'].includes(item.bussiness)) {
                        setAnchorEl(e.currentTarget);
                    }
                }}
            >
                <Stack direction="row" alignItems="center" spacing={2}>
                    {openButton && (
                        <img
                            style={{
                                width: '80px',
                                height: '80px',
                                borderRadius: '5px',
                                backgroundColor: '#999',
                            }}
                            src={`${glb_sv.urlGetProductImage(item?.img_device || item?.pic_device)}`}
                            alt=""
                        />
                    )}
                    <Typography variant="subtitle2">{glb_sv.convertMultipleLanguages(item.device_nm)}</Typography>
                </Stack>
            </TableCell>
            <TableCell>{item.device_cd}</TableCell>
            <TableCell align="left">
                <Stack display={'flex'} flexDirection={'column'}>
                    <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                        {t('cabinet')}: {item.cabinet_nm}
                    </Typography>
                    <Typography variant="subtitle3" noWrap>
                        {t('drawer')}: {item.drawer_nm}
                    </Typography>{' '}
                    <Typography variant="subtitle3" noWrap>
                        {t('cell')}: {`[ ${item?.cell_lc?.row} : ${item?.cell_lc?.column} ]`}
                    </Typography>
                </Stack>
            </TableCell>
            <TableCell>
                <Typography variant="subtitle2" noWrap color="primary">
                    {item.user_nm}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography variant="subtitle2" noWrap color="primary">
                    {item.user_assign_nm}
                </Typography>
            </TableCell>
            <TableCell align="left">{item.qty}</TableCell>
            <TableCell align="right" style={{ maxWidth: '200px' }}>
                <Label
                    color={
                        STATUS_COLOR[
                            ['8', '9', '7', '10', '11', '12', '13'].includes(item.status) ? item.status : item.bussiness
                        ]
                    }
                >
                    {return_name_status(
                        ['8', '9', '7', '10', '11', '12', '13'].includes(item.status) ? item.status : item.bussiness
                    )}
                </Label>
            </TableCell>
            <TableCell align="left">{item.note}</TableCell>
            {['cdr', 'rde', 'all', '7'].includes(valueSearch.status) && (
                <TableCell>{item.qty_change_request}</TableCell>
            )}
            {['cdr', 'rde', 'all', '7'].includes(valueSearch.status) && (
                <TableCell>
                    {(['cdr', 'rde'].includes(item.bussiness) || item.status === '7') &&
                        (item.damaged_before_use_device === '1' ? t('before_use') : t('during_use'))}
                </TableCell>
            )}
            {['cdr', 'all'].includes(valueSearch.status) && (
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {['5', '6', '7'].includes(item.status) ? item?.user_approve_grindding_nm : item.user_approve_nm}
                    </Typography>
                </TableCell>
            )}
            {['cdr', 'all'].includes(valueSearch.status) && (
                <TableCell align="left">
                    {['5', '6', '7'].includes(item.status)
                        ? item.approve_grindding_or_reject_date &&
                          glb_sv.formatDate(item.approve_grindding_or_reject_date, 'YYYYMMDDHHmmss')
                        : item.approve_or_reject_date &&
                          glb_sv.formatDate(item.approve_or_reject_date, 'YYYYMMDDHHmmss')}
                </TableCell>
            )}
            {['cdr', 'rde', 'all', '7'].includes(valueSearch.status) && (
                <TableCell align="left">{item.note_repair_device}</TableCell>
            )}
            {['cdr', 'rde', 'all', '7'].includes(valueSearch.status) && (
                <TableCell align="left">
                    {(['cdr', 'rde'].includes(item.bussiness) || item.status === '7') && (
                        <Stack display={'flex'} flexDirection={'column'}>
                            <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                                {t('cabinet')}: {item.cabinet_request_name}
                            </Typography>{' '}
                            <Typography variant="subtitle3" noWrap>
                                {t('drawer')}: {item.drawer_request_name}
                            </Typography>{' '}
                            <Typography variant="subtitle3" noWrap>
                                {t('cell')}:{' '}
                                {`[ ${item?.cell_request_cell_lc?.row} : ${item?.cell_request_cell_lc?.column} ]`}
                            </Typography>
                        </Stack>
                    )}
                </TableCell>
            )}
            {['7', 'all', 'cdr'].includes(valueSearch.status) && (
                <TableCell style={{ textAlign: 'center' }}>
                    {(item.status === '7' || item.bussiness === 'cdr') &&
                        glb_sv.formatDate(item.date_repairing, 'YYYYMMDDHHmmss')}
                </TableCell>
            )}
            {['cdr', 'all'].includes(valueSearch.status) && (
                <TableCell align="left">
                    {['cdr'].includes(item.bussiness) && FormatNumber(item.price_repair_sharpen)}
                </TableCell>
            )}
            {['ebr', 'all'].includes(valueSearch.status) && (
                <TableCell style={{ textAlign: 'center' }}>
                    {glb_sv.formatDate(item.transaction_dt, 'YYYYMMDDHHmmss')}
                    {/* </Label> */}
                </TableCell>
            )}
            {['ebr', 'all'].includes(valueSearch.status) && (
                <TableCell style={{ textAlign: 'center' }}>
                    {['ebr', 'cdr', 'rde'].includes(item.bussiness) || item.status === '7' ? (
                        <Label
                            color={
                                (moment(item.expiry_date, 'YYYYMMDD').diff(moment(), 'days') <= 2 && 'error') ||
                                'primary'
                            }
                        >
                            {['igb'].includes(item.bussiness) || item.qty - item.qty_change_request === 0
                                ? '--/--/----'
                                : moment(item?.return_date, 'YYYYMMDD').format('DD/MM/YYYY')}{' '}
                        </Label>
                    ) : (
                        <TableCell></TableCell>
                    )}
                </TableCell>
            )}
            {['igb', 'all'].includes(valueSearch.status) && (
                <TableCell>
                    {item.user_return_date
                        ? item.user_return_date && glb_sv.formatDate(item.user_return_date, 'YYYYMMDDHHmmss')
                        : '--/--/----'}
                </TableCell>
            )}
            {['ebr', 'rde', 'all', '7'].includes(valueSearch.status) && openButton && (
                <TableCell
                    padding="checkbox"
                    sx={{
                        position: 'sticky',
                        right: 0,
                        backgroundColor: 'white',
                        zIndex: 3,
                        backgroundColor: '#f4f6f8',
                    }}
                    ref={anchorTabEdit}
                >
                    <IconButton
                        size="large"
                        // color={'success'}
                        onClick={() => {
                            setOpenEdit(true);
                        }}
                    >
                        <MoreHorizIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorTabEdit.current}
                        open={openEdit}
                        onClose={() => setOpenEdit(false)}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem
                            size="large"
                            disabled={
                                item.bussiness === 'igb' ||
                                item.bussiness === 'cdr' ||
                                item.status === '7' ||
                                (item.bussiness === 'rde' && !isAdmin) ||
                                ['8', '9', '10', '11'].includes(item.status) ||
                                item?.qty_have_return >= item?.qty
                            }
                            onClick={() => {
                                dataRef.current = item;
                                setVisibleRequestFixDevice(true);
                            }}
                        >
                            <IconButton
                                size="large"
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                                color={'primary'}
                                disabled={
                                    item.bussiness === 'igb' ||
                                    item.bussiness === 'cdr' ||
                                    item.status === '7' ||
                                    (item.bussiness === 'rde' && !isAdmin) ||
                                    ['8', '9', '10', '11'].includes(item.status) ||
                                    item?.qty_have_return >= item?.qty
                                }
                            >
                                <Iconify icon={'mdi:build'} />
                                <Typography style={{ marginLeft: 10 }}>{t('bad_report')}</Typography>
                            </IconButton>
                        </MenuItem>
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem
                            size="large"
                            disabled={
                                item.status !== '7' ||
                                item.user_approve_grindding_id !== user.id ||
                                item?.qty_have_return >= item?.qty
                            }
                            onClick={() => {
                                dataRef.current = item;
                                setVisibleConfirmFixDevice(true);
                            }}
                        >
                            <IconButton
                                size="large"
                                color={'primary'}
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                                disabled={
                                    item.status !== '7' ||
                                    item.user_approve_grindding_id !== user.id ||
                                    item?.qty_have_return >= item?.qty
                                }
                            >
                                <Iconify icon={'mdi:wrench-check'} />
                                <Typography style={{ marginLeft: 10 }}>{t('finished_fix')}</Typography>
                            </IconButton>
                        </MenuItem>
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem
                            size="large"
                            onClick={() => {
                                dataRef.current = item;
                                setOpenChangeRequestDevice(true);
                            }}
                            disabled={
                                item.bussiness === 'igb' ||
                                item.bussiness === 'cdr' ||
                                item.bussiness === 'rde' ||
                                item.status === '7' ||
                                ['8', '9', '10', '11'].includes(item.status) ||
                                item?.qty_have_return >= item?.qty
                            }
                        >
                            <IconButton
                                color={'info'}
                                disableRipple
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                                disabled={
                                    item.bussiness === 'igb' ||
                                    item.bussiness === 'cdr' ||
                                    item.bussiness === 'rde' ||
                                    item.status === '7' ||
                                    ['8', '9', '10', '11'].includes(item.status) ||
                                    item?.qty_have_return >= item?.qty
                                }
                            >
                                <Iconify color={'info'} icon={'mdi:package-variant'} />{' '}
                                <Typography style={{ marginLeft: 10 }}>{t('request_change_device')}</Typography>
                            </IconButton>
                        </MenuItem>

                        {item.status === '11' && (
                            <>
                                <Divider sx={{ my: 0.5 }} />
                                <MenuItem
                                    size="large"
                                    onClick={() => {
                                        dataRef.current = item.id;
                                        setOpenTakeDevice(true);
                                    }}
                                    disabled={!(item.user_id === user.id || isAdmin)}
                                >
                                    <IconButton
                                        color={'info'}
                                        disableRipple
                                        style={{
                                            padding: 0,
                                            margin: 0,
                                        }}
                                        disabled={!(item.user_id === user.id || isAdmin)}
                                    >
                                        <Iconify color={'info'} icon={'mdi:package-variant'} />{' '}
                                        <Typography style={{ marginLeft: 10 }}>{t('take_device')}</Typography>
                                    </IconButton>
                                </MenuItem>
                            </>
                        )}
                    </Menu>
                </TableCell>
            )}
            <ToolTipCustomTakeDevice open={anchorEl} handleClose={() => setAnchorEl(null)} item={item} />
        </TableRow>
    );
};

export default ItemListBorrowDevice;
